<template>
  <div class="container">
    <div class="result">
      <i class="fas" :class="ok ? 'fa-check-circle success' : 'fa-times-circle fail'"></i>
      <h2>{{ ok ? '绑定成功' : '绑定失败' }}</h2>
      <p>{{ ok ? '采集盒已成功绑定到当前账户' : '请检查信息后重试' }}</p>
      <div class="actions">
        <router-link class="btn" to="/mine"><i class="fas fa-home"></i> 返回我的</router-link>
        <router-link class="btn outline" to="/bind"><i class="fas fa-redo"></i> 重新绑定</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BindResult',
  computed: {
    ok () {
      return this.$route.query.ok === '1'
    }
  }
}
</script>

<style scoped>
.container {  margin: 0 auto 64px; background: #fff; border-radius: 16px;   box-shadow: 0 8px 20px rgba(0,0,0,0.06); overflow: hidden; }
.result { text-align: center; padding: 40px 20px; }
.result i { font-size: 72px; margin-bottom: 16px; }
.success { color: #2ecc71; }
.fail { color: #e74c3c; }
.actions { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-top: 20px; }
.btn { background: linear-gradient(45deg, #3498db 0%, #2ecc71 100%); color: #fff; border: none; padding: 12px; border-radius: 10px; text-decoration: none; display: inline-block; }
.btn.outline { background: #fff; color: #3498db; border: 1px solid #3498db; }
</style>
